export const FEEDBACK_STATUSES = { OPEN: "open", WORKING: "working", CLOSED: "closed" } as const;
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[keyof typeof FEEDBACK_STATUSES];
export const FEEDBACK_AUTHOR_KINDS = { MERCHANT: "merchant", ADMIN: "admin" } as const;
export type FeedbackAuthorKind = (typeof FEEDBACK_AUTHOR_KINDS)[keyof typeof FEEDBACK_AUTHOR_KINDS];
export const FEEDBACK_LIMITS = {
  TITLE_MIN: 3,
  TITLE_MAX: 150,
  MESSAGE_MIN: 10,
  MESSAGE_MAX: 2000,
  REPLY_MIN: 1,
} as const;
export function isFeedbackStatus(value: unknown): value is FeedbackStatus {
  return Object.values(FEEDBACK_STATUSES).some((status) => status === value);
}
export function feedbackValidationError(title: string, message: string): string | undefined {
  if (
    title.trim().length < FEEDBACK_LIMITS.TITLE_MIN ||
    title.trim().length > FEEDBACK_LIMITS.TITLE_MAX
  )
    return "Title must contain 3–150 characters.";
  if (
    message.trim().length < FEEDBACK_LIMITS.MESSAGE_MIN ||
    message.trim().length > FEEDBACK_LIMITS.MESSAGE_MAX
  )
    return "Message must contain 10–2000 characters.";
  return undefined;
}
export function feedbackReplyValidationError(message: string): string | undefined {
  return message.trim().length < FEEDBACK_LIMITS.REPLY_MIN ||
    message.trim().length > FEEDBACK_LIMITS.MESSAGE_MAX
    ? "Reply must contain 1–2000 characters."
    : undefined;
}
